import React from 'react';
import { useTranslation } from 'react-i18next';
import FeatureCards from "../../../../components/FeatureCards/FeatureCards";
import CTA from "../../../../components/Constant/cta/CTA";
import TimelineSection from "../../../../components/TimelineSection/TimelineSection";
import WhySection from "../../../../components/WhySection/WhySection";
import LocationTimeline from "../../../../components/LocationTimeline/LocationTimeline";
import IntroSection from "../../../../components/IntroSection/IntroSection";
import FAQList from "../../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../../../components/InfoBlocks/InfoBlocks";
import SEO from "../../../../utils/SEO";

export default function ForexBrokerageLicenseCyprus (){
    const { t } = useTranslation();
    const tp = (k, d) => t(`pages.forex-brokerage-license-cyprus.${k}`, d);
    const obj = (k) => tp(k, { returnObjects: true });

    return (
        <main className='main'>
            <SEO
                title={tp('seo.title')}
                description={tp('seo.description')}
                keywords={tp('seo.keywords')}
                url="/forex-brokerage-license-cyprus"
            />

            <IntroSection
                title={tp('intro.title')}
                subtitle={tp('intro.subtitle')}
                description={tp('intro.description')}
                badges={obj('intro.badges')}
                buttonText={tp('intro.button')}
                buttonLink="/quote"
                imageSrc={require("../../../../assets/images/services/forex-brokerage-license-cyprus-hero.png")}
                imageAlt={tp('intro.imageAlt')}
            />

            <section className='section'>
                <div className="container">
                    <WhySection title={tp('why.title')} subtitle={tp('why.subtitle')} blocks={[{ items: obj('why.items') }]} />

                    <InfoBlocks title={tp('types.title')} subtitle={tp('types.subtitle')} blocks={obj('types.blocks')} />

                    <LocationTimeline title={tp('benefits.title')} item={obj('benefits.item')} />

                    <FeatureCards title={tp('process.title')} features={obj('process.features')} />

                    <TimelineSection title={tp('timeline.title')} items={obj('timeline.items')} />

                    <DetailsSection title={tp('whyUs.title')} items={obj('whyUs.items')} />

                    <FAQList data={obj('faq.items')} title={tp('faq.title')}/>

                    <Testimonials title={tp('testimonials.title')} testimonials={obj('testimonials.items')} />

                    <CTA title={tp('cta.title')} description={tp('cta.description')} buttonText={tp('cta.button')} buttonLink="/quote" />
                </div>
            </section>
        </main>
    );
};
